module.exports = __webpack_public_path__ + "img/project_screenshot_3.efef2809.webp";